import React, {useCallback} from 'react';
import {Button} from "presentation/common";
import clsx from "clsx";
import {SearchIcon} from "presentation/common/components/style-guide/icons";
import {useMyDocuments} from "./use-my-documents";
import {NotFoundDocs} from "./components/not-found-docs/not-found-docs";
import {EmptyMessage} from "./components/empty-message/empty-message";
import {DocumentItem} from "./components/document-item/document-item";
import Input from "presentation/common/components/style-guide/form/input/Input";

import styles from './my-documents.module.scss';

export const MyDocumentsPage = () => {
  const {isLoading, documents, filterBy, onChangeFilterBy, onChangeInnerFilterBy, goToNewReport, goToDocumentDetail} = useMyDocuments();

  const onChange = useCallback(event => {
    onChangeInnerFilterBy(event.target.value);
    onChangeFilterBy(event.target.value);
  }, []);

  return (
    <div className="w-full h-full flex flex-col p-4">
      <div className={styles.inputContainer}>
        <div className="flex gap-2 md:items-center w-full flex-col md:w-max md:flex-row items-start">
          <span className="text-primary font-semibold whitespace-nowrap">MIS INSCRIPCIONES</span>
          <Input
            label=""
            name="search"
            placeholder="Buscar ..."
            prefixIcon={<SearchIcon/>}
            type="email"
            value={filterBy || ''}
            onChange={onChange}
            className={clsx("w-full sm:w-max", { hidden: !isLoading && !filterBy && !documents?.length})}
          />
        </div>


        {
          !(!isLoading && !filterBy && !documents?.length) &&
          <Button label="Solicitar Inscripción" onClick={goToNewReport}/>
        }
      </div>

      {!isLoading && !filterBy && !documents?.length && <EmptyMessage/>}
      {filterBy && !documents?.length && <NotFoundDocs/>}

      {
        documents?.length > 0 && (
          <div className={styles.listContainer}>
            {
              documents.map(doc => <DocumentItem doc={doc} key={doc.unique_id} onClick={goToDocumentDetail}/>)
            }
          </div>
        )
      }
    </div>
  );
};
